<app-event-dyn-header-filters (filtersChange)="onFiltersChange($event)"></app-event-dyn-header-filters>
<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<app-event-dyn-chart *ngIf="!isLoading && !!filters?.selectedLocation && filteredMeasures?.length > 0"
                           [filters]="filters" [measures]="filteredMeasures"></app-event-dyn-chart>
<app-event-dyn-list-table *ngIf="!isLoading && !!filters?.selectedLocation && filteredMeasures?.length > 0"
                           [filters]="filters" [measures]="filteredMeasures"></app-event-dyn-list-table>
